type JstValueFetchableDate = {
	date: Date
}

// どのタイムゾーンにいても、getHours などで時刻 `date` の日本時間の値が取れるような、Date 型を返す (`date` の timestamp とは違う timestamp を持つ Date 型が帰る)
//
// 詳しくは src/utils/jst_date_print_test.ts を参照
const newJstValueFetchableDate = (date: Date): JstValueFetchableDate => {
	// timestamp - timezone offset
	// 例 UTC時間: 2025-10-05T12:00:00Z の場合
	// - 日本にいる場合(UTC+9): 2025-10-05T03:00:00Z
	// - アメリカにいる場合(UTC-4): 2025-10-05T16:00:00Z
	const utcTime = date.getTime() + date.getTimezoneOffset() * 60000

	// timestamp - timezone offset + 9 hours
	// 例 UTC時間: 2025-10-05T12:00:00Z の場合
	// - 日本にいる場合(UTC+9): 2025-10-05T12:00:00Z
	// - アメリカにいる場合(UTC-4): 2025-10-06T01:00:00Z
	const jstTime = utcTime + 9 * 60 * 60 * 1000 // UTC+9

	// getHours の結果: 21 (UTC時間 - timezone offset + 9 hours + timezone offset = UTC時間+9 hours の Hour の値が取得できる)
	// - 日本にいる場合(UTC+9): 2025-10-05T12:00:00Z + 9 hours => 2025-10-05T21:00:00+09:00 => getHours() は 21
	// - アメリカにいる場合(UTC-4): 2025-10-06T01:00:00Z - 4 hours => 2025-10-05T21:00:00-04:00 => getHours() は 21
	return { date: new Date(jstTime) }
}

export const getJstFullYear = (date: Date): number => {
	const jstValueFetchableDate = newJstValueFetchableDate(date)
	return jstValueFetchableDate.date.getFullYear()
}

// returns 0-11
export const getJstMonth = (date: Date): number => {
	const jstValueFetchableDate = newJstValueFetchableDate(date)
	return jstValueFetchableDate.date.getMonth()
}

// date: dd ((day: 曜日(0-6)) とは違うので注意)
export const getJstDate = (date: Date): number => {
	const jstValueFetchableDate = newJstValueFetchableDate(date)
	return jstValueFetchableDate.date.getDate()
}

// day: 曜日(0-6) ((date: dd) とは違うので注意)
export const getJstDay = (date: Date): number => {
	const jstValueFetchableDate = newJstValueFetchableDate(date)
	return jstValueFetchableDate.date.getDay()
}

export const getJstHours = (date: Date): number => {
	const jstValueFetchableDate = newJstValueFetchableDate(date)
	return jstValueFetchableDate.date.getHours()
}

export const getJstMinute = (date: Date): number => {
	const jstValueFetchableDate = newJstValueFetchableDate(date)
	return jstValueFetchableDate.date.getMinutes()
}

export const getJstSecond = (date: Date): number => {
	const jstValueFetchableDate = newJstValueFetchableDate(date)
	return jstValueFetchableDate.date.getSeconds()
}

export const getJstTwoDigitMonthStr = (date: Date): string => {
	const month = (getJstMonth(date) + 1).toString().padStart(2, "0")
	return month
}

export const getJstTwoDigitDateStr = (date: Date): string => {
	const day = getJstDate(date).toString().padStart(2, "0")
	return day
}

export const getJstTwoDigitHourStr = (date: Date): string => {
	const hour = getJstHours(date).toString().padStart(2, "0")
	return hour
}

export const getJstTwoDigitMinuteStr = (date: Date): string => {
	const minute = getJstMinute(date).toString().padStart(2, "0")
	return minute
}

export const getJstTwoDigitSecondStr = (date: Date): string => {
	const second = getJstSecond(date).toString().padStart(2, "0")
	return second
}
